import { Button, FlexRow, IconButton } from '@epam/promo';
import { ReactComponent as DeleteIcon } from '@epam/assets/icons/common/action-delete-18.svg';

import { useUserRole } from 'hooks/helpers';
import { AllStatuses } from 'interfaces';
import { FormHeaderActionsProps } from './FormHeader.model';
import css from './FormHeader.module.scss';

export const FormHeaderActions = ({
  status,
  handleSaveAsDraft,
  handleSaveForApprove,
  handleReject,
  handleApprove,
  handleSendToRework,
  handleDelete,
}: FormHeaderActionsProps) => {
  const { isSuperAdmin } = useUserRole();

  const isStatusNotSaved = status === AllStatuses.NOT_SAVED;
  const isStatusDraft = status === AllStatuses.DRAFT;
  const isStatusPending = status === AllStatuses.PENDING_APPROVAL;
  const isSaveAsDraftVisible = isStatusDraft || isStatusNotSaved;
  const isSaveForApproveVisible = isStatusDraft || isStatusNotSaved;
  const isRejectVisible = isSuperAdmin && isStatusPending;
  const isApproveVisible = isSuperAdmin && isStatusPending;
  const isSendToReworkVisible = isSuperAdmin && status === AllStatuses.APPROVED;
  const isDeleteVisible = isSuperAdmin && status !== AllStatuses.PUBLISHED;

  return (
    <FlexRow columnGap="6">
      {isSaveAsDraftVisible && (
        <Button
          caption="Save as draft"
          color="blue"
          fill="white"
          isDisabled={!isStatusNotSaved}
          rawProps={{ 'data-testid': 'save-draft-btn' }}
          onClick={handleSaveAsDraft}
        />
      )}
      {isSaveForApproveVisible && (
        <Button
          caption="Save for approve"
          color="green"
          rawProps={{ 'data-testid': 'save-for-approve-btn' }}
          onClick={handleSaveForApprove}
        />
      )}
      {isRejectVisible && (
        <Button
          caption="Reject"
          color="red"
          fill="white"
          rawProps={{ 'data-testid': 'reject-btn' }}
          onClick={handleReject}
        />
      )}
      {isApproveVisible && (
        <Button
          caption="Approve"
          color="green"
          rawProps={{ 'data-testid': 'approve-btn' }}
          onClick={handleApprove}
        />
      )}
      {isSendToReworkVisible && (
        <Button
          caption="Send to rework"
          color="red"
          fill="white"
          rawProps={{ 'data-testid': 'send-to-rework-btn' }}
          onClick={handleSendToRework}
        />
      )}
      {isDeleteVisible && (
        <IconButton
          color="red"
          cx={css['form__button-icon']}
          icon={DeleteIcon}
          rawProps={{ 'data-testid': 'delete-btn' }}
          onClick={handleDelete}
        />
      )}
    </FlexRow>
  );
};
